/* eslint-disable */
/*
next-is.js 2.0 ~ Copyright (c) 2012-2016 Cedrik Boudreau, Cezary Daniel Nowak
https://github.com/Cedriking/is.js
is.js may be freely distributed under the MIT Licence.
 */

(function() {
  var root = typeof window === 'undefined' ? global : window;
  var navigator = root.navigator ? root.navigator : {};
  var object = Object;
  var proto = object.prototype;
  var ua = navigator.userAgent || "";
  var uad = navigator.userAgentData || {};
  var av = navigator.appVersion || "";
  var BARCODE_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQMAAAA9AQMAAACTGJ7hAAAABlBMVEX///8AAABVwtN+AAAAi0lEQVR4nO3KIRLDIBBA0cTsXiEY9mrENFegBoIpVwBTrpYYeoWtYTP1aVRVhy//vGH4p7zkRHVhrMaNDMbZCbC8s0SpMK9dnIt2w6qV7BtQ8jF+hsMuvguV/ArOUnhi5FlCpRzk1cWFKHsDq2EMm54MaKsX9l1cCMqMD0N8L6WBU4wls8UuzkXv1x1qGsWBFbcn3QAAAABJRU5ErkJggg==';
  var BARCODE_IMAGE_CONTENT = 'TrustStamp';
  var isClass = function(obj, klass) {
    return proto.toString.call(obj) === ("[object " + klass + "]");
  };
  var extend = function(target, source) {
    return Array.prototype.slice.call(arguments, 1).forEach(function(source) {
      var key;
      for (key in source) {
        target[key] = source[key];
      }
      return target;
    });
  };

  function iOSversion(returnInt) {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      return safariVersion(returnInt);
    }
  }
  function safariVersion(returnInt) {
    // NOTE: this function doesnt check if navigator IS actually a safari.
    //       Before using, call is.safariUA().

    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    var v = av.match(/OS (\d+)_(\d+)_?(\d+)?/) || [0, 0, 0];

    return returnInt
      ? parseInt(v[1], 10)
      : [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }

  var inAppBrowserDetectionRules = '(' + [
    // if it says it's a webview, let's go with that
    'WebView',
    // https://developer.chrome.com/docs/multidevice/user-agent/#webview_user_agent
    'Android.*Version/[0-9]\.[0-9]',
    // Also, we should save the wv detected for Lollipop
    // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
    'Android.*wv',
    // old chrome android webview agent
    'Linux; U; Android'
  ].join('|') + ')';

  var _defaultMocks = {
    navigator: navigator,
    ua: ua,
    av: av
  };

  var is = {
    _mockReset: function() {
      navigator = _defaultMocks.navigator;
      ua = _defaultMocks.ua;
      av = _defaultMocks.av;
    },
    _mock: function(varName, varValue) {
      // mock variable for testing purposes
      switch(varName) {
        case 'navigator':
          navigator = Object.assign({}, navigator, varValue);
          break;
        case 'av':
          av = varValue;
          break;
        case 'ua':
          ua = varValue;
          break;
        default:
          throw new Error(varName + ' is not defined in _mock function');
      }
    },
    criticalError: function (data) {
      return (
        data instanceof EvalError
        || (typeof InternalError !== 'undefined' && data instanceof InternalError)
        || data instanceof RangeError
        || data instanceof ReferenceError
        || data instanceof SyntaxError
        || data instanceof TypeError
        || data instanceof URIError
      );
    },
    number: {
      isInteger: function(input) {
        return input % 1 === 0;
      },
      isFloat: function(input) {
        return !is.number.isInteger(input);
      },
      isOdd: function(input) {
        return !is.number.isEven(input);
      },
      isEven: function(input) {
        return is.number.isMultipleOf(input, 2);
      },
      isMultipleOf: function(input, multiple) {
        return input % multiple === 0;
      }
    },
    date: {
      isPast: function(input, d) {
        if (d == null) {
          d = input;
        }
        return input.getTime() < d.getTime();
      },
      isFuture: function(input, d) {
        if (d == null) {
          d = input;
        }
        return input.getTime() > d.getTime();
      },
      isWeekday: function(input) {
        return input.getUTCDay() > 0 && input.getUTCDay() < 6;
      },
      isWeekend: function(input) {
        return input.getUTCDay() === 0 || input.getUTCDay() === 6;
      },
      isBefore: function(input, d) {
        if (d == null) {
          d = input;
        }
        return is.date.isPast(input, d);
      },
      isAfter: function(input, d) {
        if (d == null) {
          d = input;
        }
        return is.date.isFuture(input, d);
      },
      isLeapYear: function(input) {
        var year;
        year = input.getFullYear();
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
      },
      isValid: function(input) {
        return !is.isNaN(input.getTime());
      },
      isValidPattern: function(dateString) {
        // Is pattern YYYY-MM-DD?
        if (!/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(dateString)) return false;

        var parts = dateString.split('-');
        var day = parseInt(parts[2], 10);
        var month = parseInt(parts[1], 10);
        var year = parseInt(parts[0], 10);

        // Check the range of the month
        if (month === 0 || month > 12) return false;

        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        // Is it the leap year?
        if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29;

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
      },
      isSameOrBefore: function(dateString, comparedDateString) {
        if (!is.date.isValidPattern(dateString) || !is.date.isValidPattern(comparedDateString)) return false;
        return new Date(dateString).getTime() <= new Date(comparedDateString).getTime();
      },
      isMinimumAge: function(dateString, minimumAge) {
        if (!is.date.isValidPattern(dateString)) return false;
        var parsedDate = new Date(dateString);
        var tempDate = new Date(parsedDate.getFullYear() + minimumAge, parsedDate.getMonth(), parsedDate.getDate());
        return tempDate <= new Date();
      }
    },
    string: {
      /* Added in version 1.3 */
      isCC: function(input, type) {
        var regex;
        if (!type) {
          type = 'any';
        }
        regex = (function() {
          switch (type) {
            case 'any':
              return /^[0-9]{15,16}$/;
            case 'ae' || 'AmericanExpress':
              return /^(34)|(37)\d{14}$/;
            case 'Discover':
              return /^6011\d{12}$/;
            case 'mc' || 'MasterCard':
              return /^5[1-5]\d{14}$/;
            case 'Visa':
              return /^4\d{15}$/;
          }
        })();
        return regex.test(input);
      },
      isCreditCard: function() {
        return is.string.isCC.apply(null, arguments);
      },
      isEmail: function(input) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(input);
      },
      isJSON: function(input) {
        try {
          JSON.parse(input);
          return true;
        } catch (e) {
          return false;
        }
      },
      isLatLng: function(input) {
        return /-?\d{1,3}\.\d+/.test(input);
      },
      isLatLong: function(input) {
        return is.string.isLatLng(input);
      },
      isLink: function(input) {
        return /^(ht|f)tp(s?)\:\/\/(([a-zA-Z0-9\-\._]+(\.[a-zA-Z0-9\-\._]+)+)|localhost)(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?([\d\w\.\/\%\+\-\=\&amp;\?\:\\\&quot;\'\,\|\~\;]*)$/.test(input);
      },
      isPhone: function(input, country) {
        var regex;
        if (is.isArray(country)) {
          return country.some(function(countryStr) {
            return is.string.isPhone(input, countryStr);
          });
        }
        if (!country) {
          country = 'universal';
        }
        regex = (function() {
          switch (country) {
            case 'ar':
              return /^(?:\+|[0]{2})?(54)?(:?[\s-])*\d{4}(:?[\s-])*\d{4}$/;
            case 'au':
              return /^(?:\+|0)?(?:61)?\s?[2-478](?:[ -]?[0-9]){8}$/;
            case 'ca':
              return /^(1-?)?(([2-9]\d{2})|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/;
            case 'fr':
              return /^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$/;
            case 'is':
              return /^(?:\+|[0]{2})?(354)?(:?[\s-])*\d{3}(:?[\s-])*\d{4}$/;
            case 'uk':
              return /^(?:\+|044)?(?:\s+)?\(?(\d{1,5}|\d{4}\s*\d{1,2})\)?\s+|-(\d{1,4}(\s+|-)?\d{1,4}|(\d{6}))\d{6}$/;
            case 'us':
              return /^(1-|\+1|1)?(\d{3})(:?[\s\-])*(\d{3})(:?[\s\-])*(\d{4})$/;
            case 'pl':
              return /^((0048|048|\+48|)\d{9})$/;
            case 'universal':
              return /^[+]?[0-9\-\s]{5,30}$/;
            default:
              throw new Error('There is no contry "' + country + '" specified in next-is.js');
          }
        })();
        return regex.test(input);
      },
      isZip: function(input, country) {
        var regex;
        if (!country) {
          country = 'us';
        }
        regex = (function() {
          switch (country) {
            case 'ar':
            case 'au':
            case 'at':
            case 'be':
            case 'hu':
            case 'nl':
              return /^\d{4}$/;
            case 'it':
            case 'de':
              return /^\d{5}$/;
            case 'br':
              return /^\d{5}[\-]?\d{3}$/;
            case 'ca':
              return /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
            case 'dk':
              return /^\d{3,4}$/;
            case 'es':
              return /^((0[1-9]|5[0-2])|[1-4]\d)\d{3}$/;
            case 'gb':
              return /^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? \d[ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$/;
            case 'is':
              return /^\d{3}$/;
            case 'jp':
              return /^\d{3}-\d{4}$/;
            case 'pl':
              return /^\d{2}\-\d{3}$/;
            case 'se':
              return /^\d{3}\s?\d{2}$/;
            case 'us':
              return /^(\d{5}([\-]\d{4})?)$/;
          }
        })();
        return regex.test(input);
      },
      isBlank: function(input) {
        return input.trim().length === 0;
      },
      minLen: function(input, len, trim) {
        if (trim) {
          input = input.trim();
        }
        return input.length >= len;
      },
      maxLen: function(input, len, trim) {
        if (trim) {
          input = input.trim();
        }
        return input.length <= len;
      },
      /*
       * Recognise if function is called as template tag instead of normal
       * function call
       *
       *  function test() {
       *    return is.string.isTemplateTagArgs(arguments);
       *  }
       *  test`bla bla bla` // true
       *  test(['bla bla bla']) // false
       */
      isTemplateTagArgs: function(args) {
        return args[0] instanceof Array && args[0].raw instanceof Array;
      },
      hasDigits: function(input) {
        return /\d/.test(input);
      },
      hasLowerCaseLetter: function(input) {
        return (!!input && /[a-z]/.test(input));
      },
      hasUpperCaseLetter: function(input) {
        return /[A-Z]/.test(input);
      }
    },
    isNaN: function(input) {
      return !is.isNumber(input);
    },
    isEmpty: function(input) {
      if (!input) {
        // 0, '', NaN, false, null, undefined
        return true;
      }
      if (input.hasOwnProperty('length') && !is.isFunction(input)) {
        // Array, string, arguments, NodeList
        return !input.length;
      }
      for (var key in input) {
        if (proto.hasOwnProperty.call(input, key)) {
          return false;
        }
      }
      // remember: isEmpty return true for function!
      return true;
    },
    isSameType: function(input, obj) {
      return proto.toString.call(input) === proto.toString.call(obj);
    },
    isOwnProperty: function(input, prop) {
      return proto.hasOwnProperty.call(input, prop);
    },
    isType: function(input, type) {
      return isClass(input, type);
    },
    isPromise: function(item) {
      return !!(item && typeof item.then === 'function' && typeof item.catch === 'function');
    },
    ie: function() {
      return /(msie|trident)/i.test(ua);
    },
    ie6: function() {
      return /msie 6/i.test(ua);
    },
    ie7: function() {
      return /msie 7/i.test(ua);
    },
    ie8: function() {
      return /msie 8/i.test(ua);
    },
    ie9: function() {
      return /msie 9/i.test(ua);
    },
    ie10: function() {
      return /msie 10/i.test(ua);
    },
    ie11: function() {
      return /Trident.*rv[ :]*11\./.test(ua);
    },
    firefox: function() {
      return /firefox|FxiOS/i.test(ua);
    },
    gecko: function() {
      return /gecko/i.test(ua);
    },
    opera: function() {
      return /opera/i.test(ua);
    },
    safari: function() {
      return is.safariUA() && !is.thirdPartyIOSBrowser();
    },
    safariUA: function() {
      return /webkit\W(?!.*chrome).*safari\W/i.test(ua);
    },
    thirdPartyIOSBrowser: function() {
      return is.iOS() &&
        (/(iOS|!Version|GSA|Puffin|AlohaBrowser)\//i.test(ua) ||
         / AppleWebKit\/(\d+)\.(\d+)\.(\d+)\.(\d+)\.(\d+) /i.test(ua) // dolphin browser
        );
    },
    knownCameraMalfunctionBrowser: function() {
      // browsers that don't allow camera even for a <input element

      let result = false;

      if (is.iOS() && / GSA\//.test(ua)) {
        result = true;
      }

      return result;
    },
    chrome: function() {
      return !is.edge() && /webkit\W.*(chrome|chromium|CriOS)\W/i.test(ua) && !/Puffin\//i.test(ua);
    },
    brave: function() {
      return is.iOS() && is.firefox() && / _id\//i.test(ua);
    },
    edge: function() {
      return / Edge\//.test(ua);
    },
    webkit: function() {
      return /webkit\W/i.test(ua);
    },
    mobile: function() {
      return /iphone|ipod|(android.*?mobile)|blackberry|nokia/i.test(ua);
    },
    android: function(returnInt) {
      let result = /(android)/i.test(ua);
      if (result && returnInt) {
        const androidVersion = ua.match(/android\s([0-9\.]*)/i);

        result = parseInt(androidVersion, 10) || result;
      }
      return result;
    },
    samsung: function() {
      // regexp source: https://stackoverflow.com/a/29229964/2590921
      // Not a Samsung Browser but still Samsung.
      return !!ua.match(/SAMSUNG|; SGH-|; GT-|; SM-|; SHV-|; SCH-|; SPH-/i);
    },
    samsungBrowser: function() {
      var uaTest = ua.match(/SamsungBrowser\/[0-9.]*/) || [];
      var [samsungBrowser] = uaTest;

      if (samsungBrowser) {
        // Samsung Browser - most likely it's Samsung. Return SamsungBrowser version.
        return parseFloat(samsungBrowser.replace('SamsungBrowser/', ''));
      }

      return false;
    },
    touchSupported: function() {
      var prefixes = '-webkit- -moz- -o- -ms- '.split(' ');

      if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
      }

      var query = prefixes
        .map(function(prefix) { return '(' + prefix + 'touch-enabled)'; })
        .join(',');

      return window.matchMedia(query).matches;
    },
    tablet: function() {
      var isTabletByUA = /ipad|android(?!.*mobile)/i.test(ua);
      var isIPadTryingToFoolUs = !isTabletByUA && is.safari() && is.touchSupported();
      return isTabletByUA || isIPadTryingToFoolUs;
    },
    desktop: function() {
      return !is.mobile() && !is.tablet();
    },
    kindle: function() {
      return /kindle|silk/i.test(ua);
    },
    tv: function() {
      return /googletv|sonydtv|appletv|roku|smarttv/i.test(ua);
    },
    online: function() {
      return navigator.onLine;
    },
    offline: function() {
      return !is.online();
    },
    windows: function() {
      return /win/i.test(av);
    },
    mac: function() {
      return /mac/i.test(av);
    },
    unix: function() {
      return /x11/i.test(av);
    },
    linux: function() {
      return /linux/i.test(av);
    },
    /**
     * is.iOS() returns iOS version or false when called on non-iOS browsers.
     * By default is.iOS returns array containing semver data: [MAJOR, MINOR, PATCH]
     * example: [15, 1, 0]
     *
     * When returnInt is true, integer version is returned:
     * example: 15
     *
     * @param  {Boolean} returnInt default=false;
     * @return {Number or an Array}
     */
    iOS: function(returnInt) {
      if (is.safariUA() && is.touchSupported()) {
        // NOTE: iPad PRO hides information about iOS to mimic desktop behaviour,
        // even it's 100% iOS with all iOS-related gotchas.
        return safariVersion(returnInt);
      }

      return !root.MSStream && iOSversion(returnInt);
    },
    browser: function() {
      return typeof window !== 'undefined' && (!ua.includes("Node.js") && !ua.includes("jsdom")) ||
        typeof process === 'undefined';
    },
    localStorageSupported: function() {
      // Safari, in Private Browsing Mode, looks like it supports localStorage
      // but all calls to setItem throw QuotaExceededError.
      // Thank you, Safari.
      // Another one - in Safari Paranoia Mode (cookies turned off)
      // merely looking at the localStorage prop throws a DOM exception.
      // Thanks, Apple.
      var keyName = 'next-is-test__localStorage';
      var value = '1';
      try {
        if (typeof localStorage === 'object') {
          localStorage.setItem(keyName, value);
          if (localStorage[keyName] !== value) {
            return false;
          }
          localStorage.removeItem(keyName);
          return true;
        }
      } catch (e) {}

      return false;
    },
    firefoxVersion: function() {
      var version = null;
  
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('firefox') !== -1) {
        var matches = userAgent.match(/firefox\/([0-9]+\.*[0-9]*)/);
        if (matches) {
          version = matches[1];
        }
      }
  
      return version;
    },
    userMediaSupported: function() {
      if (!is.browser()) { return false; }

      // Adapted from: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
      var mediaDevices = (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ?
        true : ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? true : false);

      var userMedia = !!mediaDevices && !!global.URL;

      // Older versions of firefox (< 21) apparently claim support but user media does not actually work
      if (ua.match(/Firefox\D+(\d+)/)) {
        const firefoxVersion = is.firefoxVersion();
        if (firefoxVersion < 21) userMedia = null;
      }

      return userMedia;
    },
    inAppBrowser: function() {
      if (!is.browser()) { return false; } // no browser, no in-app browser
      if (!is.mobile() || !is.tablet()) { return false; }

      if (ua.match(/paypal/g)) {
        return true;
      }

      if (is.iOS()) {
        const isUIWebView = !!(!window.indexedDB && !window.statusbar.visible)
        const isWKWebView = !!(window.webkit && window.webkit.messageHandlers)
          && !is.chrome();

        // https://stackoverflow.com/questions/28795476/detect-if-page-is-loaded-inside-wkwebview-in-javascript/30495399#30495399
        return isUIWebView || isWKWebView;
      }

      // UA detection is not accurate in Slack or FB, but it's worth to try.
      return !!ua.match(new RegExp(inAppBrowserDetectionRules , 'ig'));
    },
    /**
     * BarcodeDetector has an "Experimental" status. It sometimes doesn't work for no reason.
     *
     * @return {boolean}             (async) If BarcodeDetector works or not
     */
    barcodeDetectorSupportedAsync: function() {
      return new Promise(function(resolve, reject) {
        let isResolved = false;
        const resolver = (status, error_code) => {
          if (isResolved) return;

          const resolveWith = error_code && new Error(error_code);
          isResolved = true;
          (status ? resolve : reject)(resolveWith);
        };

        if (!is.browser()) return; // SSR
        if (!is.isFunction(window.BarcodeDetector)) return resolver(false, 'NOT_SUPPORTED');

        const expiredTimeout = setTimeout(() => {
          // When iOS has enabled Shape Detection feature flag then readPhoto
          // is never resolved. In such case we reject after 5 seconds.
          //
          // NOTE: no need to clear a timeout, as there is a isResolved check.
          resolver(false, 'EXPIRED');
        }, 5000);

        require('sf/helpers/barcodeDetector')
          .readPhoto(BARCODE_IMAGE)
          .then(({ result }) => {
            if (is.isArray(result) && result[0]) {
              if (result[0].rawValue === BARCODE_IMAGE_CONTENT) {
                return resolver(true);
              }
            }
            resolver(false, 'INVALID_RESULT');
          })
          .catch(() => {
            resolver(false, 'UNKNOWN_ERROR');
          });
      });
    },
    isWindowsTabletAsync: function() {
      // windows tablets are: Surface Pro, Lenovo Miix, HP Envy x2 etc
      // we detect it based on:
      // - has high pixel density
      // - has front and back cameras
      // - has touch
      return new Promise(function(resolve) {
        if (
          !is.windows()
          || !is.userMediaSupported()
          || navigator.maxTouchPoints < 3 // less than 3 touch points - potato
          || root.devicePixelRatio < 1.5
        ) return resolve(false);

        navigator
          .mediaDevices
          .enumerateDevices()
          .then(function(mediaDevices) {
            var filterVideoInputs = function(mediaDevice) { return mediaDevice.kind === 'videoinput'; };
            var videoInputs = mediaDevices.filter(filterVideoInputs);

            resolve(videoInputs.length >= 2);
          }).catch(function() { resolve(false); });
      });
    },
    /**
     * isKeyboardTrigger checks if provided element can trigger software keyboard
     *
     * @param  {DOMNode}  element
     * @return {Boolean}
     */
    isKeyboardTrigger: function(element) {
      if (!element) return false;

      return ['input', 'textarea'].includes(element.nodeName) || element.isContentEditable;
    },
    /**
     * getCapalebilities is unavailable on Firefox.
     */
    getCapabilitiesAvailable: function(element) {
      return !!(global.InputDeviceInfo && InputDeviceInfo.prototype.getCapabilities);
    },
    microBenchmarkScoreAsync: function(passes) {
      passes || (passes = 100);
      return new Promise(function(resolve) {
        var timeStart = Date.now();
        var results = [];
        var promises = [];
        for (var i = passes; i > 0; i--) {
          // regexp
          results.push(Math.random().toString(36).match(new RegExp(inAppBrowserDetectionRules , 'ig')));

          // canvas
          promises.push(testCanvas());

          // Array
          results.sort(function() { return Math.random() < 0.5 ? 1 : -1; });
        }

        // Why this ternary operator is required?
        // its important to store values of benchmarks, to prevent
        // - uglifyjs
        // - browser's micro-optimisations
        // from omiting benchmark code
        Promise.all(promises).then(function() {
          var timeOverall = Date.now() - timeStart;
          resolve(timeOverall ? timeOverall : results);
        });
      });

      function testCanvas() {
        return new Promise(function(resolve) {
          var canvas = document.createElement('canvas');
          canvas.width = canvas.height = 99;
          var ctx = canvas.getContext('2d');
          var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

          function randomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          }

          for (var i = 0; i < imgData.data.length; i++) {
            imgData.data[i] = randomInt(0, 255); // red
          }

          ctx.putImageData(imgData, 0, 0);
          canvas.style.position = 'absolute';
          canvas.style.bottom = 0;
          canvas.style.opacity = 0.01;
          document.body.appendChild(canvas);

          setTimeout(function() { canvas.parentNode.removeChild(canvas); resolve(); });
        });
      }
    },
    devToolsOpen: function() {
      function checkForDebugger() {
        // Don't perform the debugger check on local environment.
        if (ENV === 'local') {
          return false;
        }

        const startTime = Date.now();
        eval('debugger');
        const endTime = Date.now();
        return endTime - startTime > 100;
      }
    
      // Check if userAgent has changed
      if (navigator.userAgent !== ua) {
        return true;
      }
    
      // Check for debugger
      const debuggerDetected = checkForDebugger();
    
      return debuggerDetected;
    },
    
  // check devtools open by e listener for key press
  devToolsOpenByEvent: function(e) {
    let devToolsDetected = false;

    if(!e) return false;
    const shortcuts = [
        // CMD + Alt + I (Chrome, Firefox, Safari)
        { meta: true, alt: true, keyCode: 73 },
        // CMD + Alt + J (Chrome)
        { meta: true, alt: true, keyCode: 74 },
        // CMD + Alt + C (Chrome)
        { meta: true, alt: true, keyCode: 67 },
        // CMD + Shift + C (Chrome)
        { meta: true, shift: true, keyCode: 67 },
        // Ctrl + Shift + I (Chrome, Firefox, Safari, Edge)
        { ctrl: true, shift: true, keyCode: 73 },
        // Ctrl + Shift + J (Chrome, Edge)
        { ctrl: true, shift: true, keyCode: 74 },
        // Ctrl + Shift + C (Chrome, Edge)
        { ctrl: true, shift: true, keyCode: 67 },
        // F12 (Chome, Firefox, Edge)
        { keyCode: 123 },
        // CMD + Alt + U, Ctrl + U (View source: Chrome, Firefox, Safari, Edge)
        { meta: true, alt: true, keyCode: 85 },
        { ctrl: true, keyCode: 85 }
    ];

    for (const shortcut of shortcuts) {
      const match = (
          (!shortcut.meta || e.metaKey) &&
          (!shortcut.alt || e.altKey) &&
          (!shortcut.shift || e.shiftKey) &&
          (!shortcut.ctrl || e.ctrlKey) &&
          shortcut.keyCode === e.keyCode
      );

      if (match) {
          devToolsDetected = true;
          break;
      }
    }

    return devToolsDetected;
  }
  
  };
  ['Object', 'Array', 'Boolean', 'Date', 'Function', 'Number', 'String', 'RegExp'].forEach(function(type) {
    is["is" + type] = function(input) {
      return isClass(input, type);
    };
  });

  // is.iOS9(), is.iOS10() ... is.iOS19()
  for(let i = 9; i < 20; i++) {
    is[`iOS${i}`] = (function(version) {
      return () => is.iOS(true) === version;
    })(i);
  }

  // shortcut: is.number()
  var _obj = is.number;
  is.number = is.isNumber;
  extend(is.number, _obj);

  // shortcut: is.string()
  _obj = is.string;
  is.string = is.isString;
  extend(is.string, _obj);

  // shortcut: is.date()
  _obj = is.date;
  is.date = is.isDate;
  extend(is.date, _obj);

  // implement is.not.*
  var makeNot = function(inputObj) {
    return Object.keys(inputObj).reduce(function(result, key) {
      if (inputObj[key] instanceof Function) {
        result[key] = function() {
          return !inputObj[key].apply(null, arguments);
        };
      }
      if (!is.isEmpty(inputObj[key])) {
        // is.not.string.isCC
        extend(result[key], makeNot(inputObj[key]));
      }
      return result;
    }, {});
  };

  is.not = makeNot(is);

  is.appendBrowsers = function() {
    var className = 'desktop mobile edge chrome safari opera firefox android ie11 ie10 ie9 ie8 ie7 ie6 iOS iOS9 iOS10 iOS11 iOS12 iOS13 iOS14 iOS15 iOS16 iOS17'
    .split(' ')
    .reduce(function(cn, browser) {
      return cn + (is[browser]() ? ' is-browser-' + browser : '');
    }, '');
    var html = document.querySelector('html');
    var origClassName = html.getAttribute('class') || '';
    html.setAttribute('class', (origClassName + ' ' + className).trim());
  };


  // var stateSyncListeners = [];

  /**
   * Example:
   * state = is.syncState(this, ['browser', 'iOS']);
   *
   * @param  {[type]}    targetComponent [description]
   * @param  {...[type]} fields          [description]
   * @return {[type]}                    [description]
   */
  // is.syncState = (targetComponent, fields = []) => {
  //   const result = {};
  //   fields.forEach((field) => {
  //     result[`is.${field}`] = is[field]();
  //   });

  //   stateSyncListeners.push({ target: targetComponent, fields: fields });

  //   return result;
  // }

  // is.unSyncState = (targetComponent) => {
  //   for (let i = stateSyncListeners.length - 1; i >= 0; --i) {
  //     if (stateSyncListeners[i].target === targetComponent) {
  //       stateSyncListeners.splice(i, 1);
  //       break;
  //     }
  //   }
  // }

  if (typeof module === 'object' && module.exports) {
    module.exports = is;
  } else {
    root.is = is;
  }
})();
